/*
This is the Financial Route Guard, it is used to check if the user has access to the financial dashboard.

Need to change per requirements, as all users should be able to access the "New Claims" page.
*/

import React from "react";
import PropTypes from "prop-types";
import LoadingCircle from "../../utils/LoadingCircle";
import { useFinancialAccess } from "./financialAccessControl";

const FinancialUnauthorizedState = () => (
  <div
    style={{
      minHeight: "60vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "32px",
      background: "#f8fafc",
    }}
  >
    <div
      style={{
        width: "100%",
        maxWidth: "720px",
        background: "#ffffff",
        border: "1px solid #e2e8f0",
        borderRadius: "20px",
        padding: "32px",
        boxShadow: "0 12px 32px rgba(15, 23, 42, 0.08)",
      }}
    >
      <h1 style={{ margin: "0 0 12px", fontSize: "28px", color: "#0f172a" }}>
        Unauthorized access
      </h1>
      <p style={{ margin: 0, fontSize: "16px", lineHeight: 1.6, color: "#475569" }}>
        You do not have permission to access the Financial Dashboard.
      </p>
    </div>
  </div>
);

const FinancialRouteGuard = ({ children }) => {
  const { loading, canAccessFinancialDashboard } = useFinancialAccess();

  if (loading) {
    return (
      <div
        style={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <LoadingCircle label="Checking financial access..." />
      </div>
    );
  }

  if (!canAccessFinancialDashboard) {
    return <FinancialUnauthorizedState />;
  }

  return children;
};

FinancialRouteGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FinancialRouteGuard;
